import request from '../utils/request';

/**
 * 获取用户额度使用记录分页列表
 * @param {Object} params - 查询参数
 * @returns {Promise} - 返回请求结果
 */
export function getUserQuotaUsageLogList(params) {
  console.log(params);
  return request({
    url: '/user-quota-usage-logs/list',
    method: 'get',
    params
  });
} 